export default (object, key, def = undefined) => {
	if (object === undefined || object === null) {
		return def;
	}

	const ret = key.split('.').reduce((o, k) => (o === undefined || o === null ? o : o[k]), object);

	return ret !== undefined && ret !== null ? ret : def;
};
